import script from "./CompetitionPublic.vue?vue&type=script&setup=true&lang=js"
export * from "./CompetitionPublic.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/clubstyle.css?vue&type=style&index=0&lang=css&external"
import "./CompetitionPublic.vue?vue&type=style&index=1&id=c43a3460&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c43a3460"]])

export default __exports__